import 'motivate-framework/dist/css/theme-dark.css'
import Vue from 'vue'
Vue.config.devtools = true;
import App from './App.vue'
import router from './router/index'
import store from './store'
import axios from "axios";
// import './registerServiceWorker'

window.moment = require('moment')

const firebase = require("firebase/app");
// Required for side-effects
import 'firebase/firestore'
import 'firebase/auth'

import {firestorePlugin} from 'vuefire'

Vue.config.performance = true
require('./filters/filters');
window._ = require('lodash')

var hash = window.location.hash.substr(1).split(',')
//if multiple hashes add to store
var DashboardHash = hash[0]

if (!DashboardHash) {
    if (store.state.hash) {
        DashboardHash = store.state.hash
    }
} else {
    store.commit('setHash', DashboardHash)
}
Vue.prototype.$HASH = DashboardHash
const dataAPI = axios.create({
    baseURL: process.env.VUE_APP_PERFECT_COAT_API,
    timeout: 3000,
    headers: {
        'Motivate-dashboard-hash': DashboardHash, // THIS is the way to authenticate on new dashbaords
    },
});

window.DATA_API = dataAPI;

var FBconfig = JSON.parse(process.env.VUE_APP_FB_CONFIG)

DATA_API.get('dashboard/firebasetoken').then(res => {
    firebase.initializeApp(FBconfig);
    firebase.auth().signInWithCustomToken(res.data).catch(function (error) {
        // Handle Errors here.
        var errorCode = error.code;
        var errorMessage = error.message;
        // ...
    });

// const db = firebase.firestore()

    Vue.prototype.$FB = firebase.firestore()
    Vue.use(firestorePlugin)

    new Vue({
        router: router,
        store: store,
        render: h => h(App),
    }).$mount('#app')
})

if (process.env.NODE_ENV !== 'production') {
    firebase.initializeApp(FBconfig);
    Vue.prototype.$FB = firebase.firestore()
    Vue.use(firestorePlugin)
    firebase.auth().signInAnonymously().catch(function (error) {
        // Handle Errors here.
        var errorCode = error.code;
        var errorMessage = error.message;
        // ...
    });
    new Vue({
        router: router,
        store: store,
        render: h => h(App),
    }).$mount('#app')
}